import {setDefaultOptions, type Locale} from 'date-fns';
import {de, enUS, es, fr, nl} from 'date-fns/locale';
import {defineNuxtPlugin} from '#imports';
import {useLocale} from '../composables/useLocale';

const dateFnsLocaleByLang: {[key: string]: Locale} = {
    de,
    es,
    fr,
    nl,
    en: enUS,
};

function getDateFnsLocale(locale?: string): Locale {
    const [lang] = locale?.split('-') ?? ['en'];

    return dateFnsLocaleByLang[lang ?? 'en'] ?? enUS;
}

export default defineNuxtPlugin(() => {
    const {locale} = useLocale();
    setDefaultOptions({
        locale: getDateFnsLocale(locale.value),
    });
});
